import { Pass } from '@domain/passes';
import { useGenericQuery } from '@hooks/use-generic-query';
import { request } from '@utils/request/request';
import { RequestError, RequestMethod } from '@utils/request/request.type';

import { QUERY_KEYS } from './constants';

export interface GetCompanyPassesResponse {
  seasonPass: Pass[];
  staffPass: Pass[];
}

interface Params {
  validFrom?: number;
  validUntil?: number;
  status?: string[];
  orderBy?: string;
  sort?: string;
}

export const getCompanyPassesQueryKey = (companyId: string, params?: Params) => [
  QUERY_KEYS.getCompanyPasses,
  companyId,
  params,
];

const getCompanyPasses = async ({ companyId = '', params }: { companyId?: string; params?: Params }) => {
  const searchParams = new URLSearchParams({ limit: '100' });

  if (params?.validFrom !== undefined) searchParams.set('validFrom', String(params.validFrom));
  if (params?.validUntil !== undefined) searchParams.set('validUntil', String(params.validUntil));
  if (params?.status?.length) params.status.forEach((s) => searchParams.append('status[]', s));
  if (params?.orderBy) searchParams.set('orderBy', params.orderBy);
  if (params?.sort) searchParams.set('sort', params.sort);

  const url = `${import.meta.env.VITE_OFFERS_HOST}/v1/nightgraph/companies/${companyId}/passes?${searchParams.toString()}`;

  return request({ url, method: RequestMethod.GET });
};

export const useGetCompanyPasses = ({
  companyId = '',
  params,
  enabled,
}: {
  companyId?: string;
  params?: Params;
  enabled: boolean;
}) => {
  return useGenericQuery<GetCompanyPassesResponse, RequestError>(
    getCompanyPassesQueryKey(companyId, params),
    () => getCompanyPasses({ companyId, params }),
    {
      enabled,
    }
  );
};
